import './App.css';
import React, { useMemo } from 'react';
import EscapeRoom from './components/EscapeRoom';
import TeacherDashboard from './components/TeacherDashboard';

function App() {
  const isDashboard = useMemo(() => {
    if (typeof window === 'undefined') return false;
    return window.location.pathname.toLowerCase().includes('dashboard');
  }, []);

  if (isDashboard) {
    return <TeacherDashboard />;
  }

  return <EscapeRoom />;
}

export default App;
